module.exports = __webpack_public_path__ + "img/bg_instagram_feed.4f34c4d6.png";